'use client'

import clsx from 'clsx'
import s from './style.module.scss'
import {useState} from 'react'
import {createPortal} from 'react-dom'
import OverlaySelector from './overlay-selector'
import TranslationIcon from '@app/components/icons/translate/translation-icon'
import {useParams} from 'next/navigation'
import {LanguageCodes, fallbackLang} from '@app/i18n/settings'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

interface Props {
  className?: string
  langTranslate: Record<string, string>
}

const TranslateButton = ({className, langTranslate}: Props) => {
  const [isTranslationActive, setTranslationActive] = useState<boolean>(false)
  const params = useParams<{lang: LanguageCodes}>()

  return (
    <>
      <button
        onClick={() => {
          setTranslationActive(true)
          triggerAnalytics('lang-selector-clicked', {'current-lang': params?.lang || fallbackLang}).sendAll()
        }}
        className={clsx(s.translate_btn, className)}
        data-testid='intro-language-btn'
      >
        <span>
          <TranslationIcon className='w-16 lg:w-20' />
        </span>
        <span className={s.line}>|</span>
        <span>{langTranslate[params?.lang || fallbackLang]}</span>
      </button>
      {isTranslationActive &&
        createPortal(
          <OverlaySelector langTranslate={langTranslate} closeTranslation={() => setTranslationActive(false)} />,
          document.body,
        )}
    </>
  )
}

export default TranslateButton
